<template>
  <div>
    <!-- Schedule information -->
    <h4>Provisioning Schedule <span v-if="!loading && !schedule" class="small">(not scheduled)</span></h4>
    <div v-if="schedule">
      <div class="row">
        <div class="col-sm-12">
          <p>Provisioning will run daily at: <b>{{ formatScheduleTime() }}</b></p>
          <div class="form-group">
            <button class="btn btn-primary" @click="editSchedule">Edit Schedule</button>
            <button class="btn btn-danger" @click="confirmDeleteSchedule" :disabled="deleteLoading">Delete Schedule</button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <button class="btn btn-primary" @click="setupSchedule">Set up Schedule</button>
    </div>
    
    <!-- Schedule Form -->
    <template v-if="showScheduleForm">
      <AutoprovisioningScheduleForm 
        :domain-uuid="domainUuid"
        :domain-name="domainName"
        :existing-schedule="scheduleFormMode === 'edit' ? schedule : null"
        @scheduleCreated="handleScheduleCreated" 
        @scheduleUpdated="handleScheduleUpdated" 
        @cancel="showScheduleForm = false"
      />
    </template>
    
    <!-- Confirmation Modal -->
    <modal :value="showDeleteScheduleModal" title="Confirm Delete" @hide="showDeleteScheduleModal = false" @input="showDeleteScheduleModal = $event">
      <p>Are you sure you want to delete this provisioning schedule?</p>
      <div slot="footer">
        <button type="button" class="btn btn-default" @click="showDeleteScheduleModal = false" :disabled="deleteLoading">Cancel</button>
        <button type="button" class="btn btn-danger" @click="deleteSchedule" :disabled="deleteLoading">
          <i class="fa fa-spinner fa-spin" v-if="deleteLoading"></i>
          Delete
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import AutoprovisioningScheduleForm from './AutoprovisioningScheduleForm.vue'
import { Modal } from 'uiv'
import { formatScheduleTimeWithTimezone } from '../../utils/formatters'

export default {
  name: 'AutoprovisioningSchedule',
  components: {
    AutoprovisioningScheduleForm,
    Modal
  },
  props: {
    domainUuid: {
      type: String,
      required: true
    },
    domainName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      schedule: null,
      loading: false,
      error: null,
      showScheduleForm: false,
      scheduleFormMode: 'create',
      showDeleteScheduleModal: false,
      deleteLoading: false
    }
  },
  methods: {
    fetchSchedule() {
      this.loading = true
      this.$angularWorld.adminApi.getAutoprovisioningSchedule(this.domainUuid)
        .then(schedule => {
          this.schedule = schedule
          this.loading = false
        })
        .catch(error => {
          console.error('Error fetching schedule:', error)
          this.loading = false
          this.error = error.message || 'An error occurred while fetching the schedule'
        })
    },
    setupSchedule() {
      this.scheduleFormMode = 'create'
      this.showScheduleForm = true
    },
    editSchedule() {
      this.scheduleFormMode = 'edit'
      this.showScheduleForm = true
    },
    confirmDeleteSchedule() {
      this.showDeleteScheduleModal = true
    },
    deleteSchedule() {
      this.deleteLoading = true
      this.$angularWorld.adminApi.deleteAutoprovisioningSchedule(this.domainUuid)
        .then(() => {
          this.deleteLoading = false
          this.showDeleteScheduleModal = false
          this.schedule = null
        })
        .catch(error => {
          console.error('Error deleting schedule:', error)
          this.deleteLoading = false
          this.showDeleteScheduleModal = false
          this.error = error.message || 'An error occurred while deleting the schedule'
        })
    },
    handleScheduleCreated() {
      this.showScheduleForm = false
      this.fetchSchedule()
    },
    handleScheduleUpdated() {
      this.showScheduleForm = false
      this.fetchSchedule()
    },
    formatScheduleTime(scheduleObj) {
      const schedule = scheduleObj || this.schedule
      return formatScheduleTimeWithTimezone(schedule)
    }
  },
  mounted() {
    this.fetchSchedule()
  }
}
</script>

<style scoped>
.well {
  margin-top: 20px;
}
</style>
